module.exports = "@media (max-width: 573px) {\n  .container-slider {\n    width: 100%; } }\n"